"use strict";

var _slicedToArray = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var EventInit = require("../generated/EventInit");

var EventImpl = /*#__PURE__*/function () {
  function EventImpl(args, privateData) {
    _classCallCheck(this, EventImpl);

    var _args = _slicedToArray(args, 2),
        type = _args[0],
        _args$ = _args[1],
        eventInitDict = _args$ === void 0 ? this.constructor.defaultInit : _args$;

    this.type = type;
    this.bubbles = false;
    this.cancelable = false;

    for (var key in eventInitDict) {
      if (key in this.constructor.defaultInit) {
        this[key] = eventInitDict[key];
      }
    }

    for (var _key in this.constructor.defaultInit) {
      if (!(_key in this)) {
        this[_key] = this.constructor.defaultInit[_key];
      }
    }

    this.target = null;
    this.currentTarget = null;
    this.eventPhase = 0;
    this._initializedFlag = true;
    this._stopPropagationFlag = false;
    this._stopImmediatePropagationFlag = false;
    this._canceledFlag = false;
    this._dispatchFlag = false;
    this.isTrusted = privateData.isTrusted || false;
    this.timeStamp = Date.now();
  }

  _createClass(EventImpl, [{
    key: "stopPropagation",
    value: function stopPropagation() {
      this._stopPropagationFlag = true;
    }
  }, {
    key: "stopImmediatePropagation",
    value: function stopImmediatePropagation() {
      this._stopPropagationFlag = true;
      this._stopImmediatePropagationFlag = true;
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      if (this.cancelable) {
        this._canceledFlag = true;
      }
    }
  }, {
    key: "_initialize",
    value: function _initialize(type, bubbles, cancelable) {
      this.type = type;
      this._initializedFlag = true;
      this._stopPropagationFlag = false;
      this._stopImmediatePropagationFlag = false;
      this._canceledFlag = false;
      this.isTrusted = false;
      this.target = null;
      this.bubbles = bubbles;
      this.cancelable = cancelable;
    }
  }, {
    key: "initEvent",
    value: function initEvent(type, bubbles, cancelable) {
      if (this._dispatchFlag) {
        return;
      }

      this._initialize(type, bubbles, cancelable);
    }
  }, {
    key: "srcElement",
    get: function get() {
      return this.target;
    }
  }, {
    key: "returnValue",
    get: function get() {
      return !this._canceledFlag;
    },
    set: function set(v) {
      if (this.cancelable && v === false) {
        this._canceledFlag = true;
      }
    }
  }, {
    key: "defaultPrevented",
    get: function get() {
      return this._canceledFlag;
    }
  }, {
    key: "cancelBubble",
    get: function get() {
      return this._stopPropagationFlag;
    },
    set: function set(v) {
      if (v) {
        this._stopPropagationFlag = true;
      }
    }
  }]);

  return EventImpl;
}();

EventImpl.defaultInit = EventInit.convert(undefined);
module.exports = {
  implementation: EventImpl
};